import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  createPromotion,
  listPromotions,
  updatePromotion,
  deletePromotion,
} from "../../function/promotion";
import { listProduct, readProduct } from "../../function/product";
import MenubarAdmin from "../../layouts/MenubarAdmin";
import Select from "react-select";

const Promotion = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  // const [discount, setDiscount] = useState("");
  const [discount, setDiscount] = useState([{ type: "percentage", value: 0 }]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [promotions, setPromotions] = useState([]);
  const [editingPromotion, setEditingPromotion] = useState(null);
  const { user } = useSelector((state) => ({ ...state }));
  const [employeeDiscount, setEmployeeDiscount] = useState("");

  const [currentPage, setCurrentPage] = useState(1); // หน้าปัจจุบัน
  const promotionsPerPage = 5; // จำนวนโปรโมชั่นต่อหน้า

  useEffect(() => {
    loadPromotions();
    loadProducts();
  }, []);

  const loadPromotions = () => {
    listPromotions().then((res) => {
      setPromotions(res.data);
    });
  };

  const loadProducts = () => {
    listProduct()
      .then((res) => {
        // กรองสินค้าที่ไม่มี discountedPrice
        const filteredProducts = res.data.filter((product) => !product.discountedPrice);
        setProducts(filteredProducts);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to load products");
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const promotionData = {
      title,
      description,
      discount,
      employeeDiscount: Number(employeeDiscount),
      startDate,
      endDate,
      products: selectedProducts,
    };
    console.log("Promotion Data:", promotionData);

    if (editingPromotion) {
      updatePromotion(user.token, editingPromotion._id, promotionData)
        .then((res) => {
          toast.success("Promotion updated");
          loadPromotions();
          loadProducts();
          resetForm();
        })
        .catch((err) => {
          toast.error(err.response.data.error);
        });
    } else {
      createPromotion(user.token, promotionData)
        .then((res) => {
          toast.success("Promotion created");
          loadPromotions();
          loadProducts();
          resetForm();
        })
        .catch((err) => {
          toast.error(err.response.data.error);
        });
    }
  };

  const handleRemove = (id) => {
    if (window.confirm("Are you sure you want to delete this promotion?")) {
      deletePromotion(user.token, id)
        .then((res) => {
          toast.success("Promotion deleted");
          loadPromotions();
        })
        .catch((err) => {
          toast.error(err.response.data.error);
        });
    }
  };

  const handleEdit = (promotion) => {
    setEditingPromotion(promotion);
    setTitle(promotion.title);
    setDescription(promotion.description);
    setDiscount(promotion.discount);
    setStartDate(promotion.startDate);
    setEndDate(promotion.endDate);
    setSelectedProducts(promotion.products.map(p => p._id));
    setEmployeeDiscount(promotion.employeeDiscount || "");
  };

  const resetForm = () => {
    setTitle("");
    setDescription("");
    setDiscount([{ type: "percentage", value: 0 }]);
    setStartDate("");
    setEndDate("");
    setSelectedProducts([]);
    setEditingPromotion(null);
  };

  // const handleProductSelect = async (e) => {
  //   const selected = Array.from(
  //     e.target.selectedOptions,
  //     (option) => option.value
  //   );
  //   setSelectedProducts(selected);
  //   if (selected.length > 0) {
  //     try {
  //       const productId = selected[selected.length - 1]; 
  //       const res = await readProduct(productId);
  //       const product = res.data;
  //       setTitle(product.title);
  //       setDescription(product.description);
  //     } catch (err) {
  //       toast.error("Failed to load product details");
  //     }
  //   } else {
  //     setTitle("");
  //     setDescription("");
  //   }
  // };

  const handleProductSelect = async (selectedOption) => {
    if (selectedOption) {
      const productId = selectedOption.value; // ดึง ID ของสินค้าที่เลือก
      setSelectedProducts([productId]); // เก็บ ID ในรูปแบบ array (แม้จะมีเพียง 1 รายการ)
      try {
        const res = await readProduct(productId); // เรียก API เพื่อดึงข้อมูลสินค้า
        const product = res.data;
        setTitle(product.title); // อัปเดต Title
        setDescription(product.description); // อัปเดต Description
      } catch (err) {
        toast.error("Failed to load product details");
      }
    } else {
      setSelectedProducts([]); // รีเซ็ตหากไม่มีสินค้าเลือก
      setTitle(""); // รีเซ็ต Title
      setDescription(""); // รีเซ็ต Description
    }
  };


  const indexOfLastPromotion = currentPage * promotionsPerPage;
  const indexOfFirstPromotion = indexOfLastPromotion - promotionsPerPage;
  const currentPromotions = promotions.slice(indexOfFirstPromotion, indexOfLastPromotion);

  const totalPages = Math.ceil(promotions.length / promotionsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };





  const styles = {
    columnDivider: {
      borderRight: "1px solid #ccc", // เส้นแบ่ง
      paddingRight: "15px", // ระยะห่างด้านขวา
    },
    promotionList: {
      minHeight: "450px", // กำหนดความสูงขั้นต่ำ
    },
    paginationContainer: {
      textAlign: "center", // จัดตำแหน่งปุ่มให้อยู่ตรงกลาง
      marginTop: "10px",
    },
  };
  return (
    <div className="container-fluid">
      <div className="row">
        {/* <div className="col-md-2">
          <MenubarAdmin />
        </div> */}
        <div className="col-md-5 mt-3" style={styles.columnDivider}>
          <h4>CreatePromotions</h4>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Products</label>
              <Select
                options={products.map((product) => ({
                  value: product._id,
                  label: product.title,
                }))}
                value={
                  selectedProducts.length > 0
                    ? { value: selectedProducts[0], label: products.find((p) => p._id === selectedProducts[0])?.title }
                    : null
                }
                onChange={handleProductSelect}
                placeholder="Search and select a product"
              />
            </div>
            <div className="form-group">
              <label>Title</label>
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>
            <div className="form-group mt-3">
              <label>Description</label>
              <textarea
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </div>
            <div className="form-group mt-3">
              <label>Discount Type</label>
              <select
                className="form-control"
                value={discount[0].type}
                onChange={(e) => {
                  const updated = [...discount];
                  updated[0].type = e.target.value;
                  setDiscount(updated);
                }}
              >
                <option value="percentage">Percentage (%)</option>
                <option value="amount">Fixed Amount (฿)</option>
                <option value="buyGetDiscount">Buy X Get Discount (%)</option>
              </select>
            </div>

            {discount[0].type === "buyGetDiscount" && (
              <>
                <div className="form-group mt-3">
                  <label>Min Quantity (ซื้อขั้นต่ำ)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={discount[0].minQuantity || ""}
                    onChange={(e) => {
                      const updated = [...discount];
                      updated[0].minQuantity = Number(e.target.value);
                      setDiscount(updated);
                    }}
                    required
                  />
                </div>
                <div className="form-group mt-3">
                  <label>Discount Value (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={discount[0].value}
                    onChange={(e) => {
                      const updated = [...discount];
                      updated[0].value = Number(e.target.value);
                      setDiscount(updated);
                    }}
                    required
                  />
                </div>
              </>
            )}

            {discount[0].type !== "buyGetDiscount" && (
              <div className="form-group mt-3">
                <label>Discount Value</label>
                <input
                  type="number"
                  className="form-control"
                  value={discount[0].value}
                  onChange={(e) => {
                    const updated = [...discount];
                    updated[0].value = Number(e.target.value);
                    setDiscount(updated);
                  }}
                  required
                />
              </div>
            )}

            {/* <div className="form-group mt-3">
              <label>Discount Value</label>
              <input
                type="number"
                className="form-control"
                value={discount[0].value}
                onChange={(e) => {
                  const updated = [...discount];
                  updated[0].value = Number(e.target.value);
                  setDiscount(updated);
                }}
                required
              />
            </div> */}
            <div className="form-group mt-3">
              <label>ส่วนลดสำหรับพนักงาน (บาท)</label>
              <input
                type="number"
                className="form-control"
                value={employeeDiscount}
                onChange={(e) => setEmployeeDiscount(e.target.value)}
                placeholder="ส่วนลดสำหรับพนักงาน"
              />
            </div>
            <div className="form-group">
              <label>Start Date</label>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>End Date</label>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                required
              />
            </div>
            <button className="btn btn-outline-primary">Save</button>
          </form>
          <hr />
          {/* <div>
            {promotions.map((promotion) => (
              <div key={promotion._id} className="alert alert-secondary">
                <span>{promotion.title}</span>
                <button
                  onClick={() => handleRemove(promotion._id)}
                  className="btn btn-sm float-right"
                >
                  Delete
                </button>
                <button
                  onClick={() => handleEdit(promotion)}
                  className="btn btn-sm float-right"
                >
                  Edit
                </button>
              </div>
            ))}
          </div> */}

        </div>
        <div className="col-md-5 mt-3">
          <h4>ListPromotions</h4>
          <div className="promotion-list mt-4" style={styles.promotionList}>
            {currentPromotions.map((promotion) => (
              <div key={promotion._id} className="alert alert-secondary"
                style={{ backgroundColor: "#f0f8ff" }}
              >
                <span>{promotion.title}</span>
                <button
                  onClick={() => handleRemove(promotion._id)}
                  className="btn btn-sm float-right"
                >
                  Delete
                </button>
                <button
                  onClick={() => handleEdit(promotion)}
                  className="btn btn-sm float-right"
                >
                  Edit
                </button>
              </div>
            ))}
          </div>
          <div className="pagination-container" style={styles.paginationContainer}>
            <div className="pagination">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  className={`btn btn-sm ${currentPage === index + 1 ? "btn-primary" : "btn-secondary"}`}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );


};

export default Promotion;
